import Image from "next/image";
import OutboundLink from "./OutboundLink";
import {
  StyledButton,
  ButtonTypes,
  ButtonSizes,
  IconTypes,
} from "./StyledButton";
import { handleOutboundClick } from "@/lib/analytics/navigation";

const Footer = () => {
  const FAQLink =
    "https://xqnavigator.wpengine.com/wp-content/uploads/2025/10/XQ-Competencies-FAQ.pdf";

  return (
    <footer className="flex h-[167px] border-t border-tab-border bg-white medium:h-[160px] print:hidden ">
      <div className="flex w-full max-w-screen-large flex-col justify-between gap-4 px-4 py-6 text-BG-60 small:px-6 large:mx-auto">
        <div className="flex w-full justify-between">
          <OutboundLink href="https://xqsuperschool.org/" className="">
            <Image src="/xq-logo.jpg" alt="XQ Logo" width={57} height={28} />
          </OutboundLink>
          <StyledButton
            buttonType={ButtonTypes.Secondary}
            size={ButtonSizes.Small}
            iconType={IconTypes.None}
            as="link"
            href={FAQLink}
            target="_blank"
            onClick={() => handleOutboundClick(FAQLink)}
          >
            FAQ
          </StyledButton>
        </div>

        <div className="flex flex-col gap-x-6 gap-y-2 small:flex-row">
          <div className="font-roobert text-base font-normal text-dark-color">
            © 2024 XQ Institute
          </div>

          {/* min width on links? */}

          <div className="flex flex-row flex-wrap gap-x-6 gap-y-2 font-roobert text-base font-semibold leading-tight text-BG-60 underline">
            <OutboundLink href="https://xqsuperschool.org/privacy-policy/">
              Privacy Policy
            </OutboundLink>

            <OutboundLink href="https://xqsuperschool.org/terms/">
              Terms of Use
            </OutboundLink>

            <OutboundLink href="https://xqsuperschool.org/about/">
              About XQ
            </OutboundLink>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
